import React from 'react';
import {
	Box,
	Grid,
	Skeleton,
	SkeletonCircle,
	HStack,
	VStack,
	Flex,
	Tabs,
	TabList,
	Tab,
} from '@chakra-ui/react';

const HeaderSkeleton = () => (
	<Box bg='white' borderRadius='2xl' border='1px solid' borderColor='gray.200' p={6}>
		<Flex justify='space-between' align='center' direction={{ base: 'column', lg: 'row' }} gap={4}>
			<VStack align='start' spacing={2} w='full'>
				<Skeleton height='14px' width='180px' borderRadius='md' />
				<Skeleton height='28px' width='260px' borderRadius='md' />
				<Skeleton height='14px' width='320px' borderRadius='md' />
			</VStack>
			<HStack w={{ base: 'full', lg: 'auto' }}>
				<Skeleton height='36px' width='120px' borderRadius='md' />
				<Skeleton height='36px' width='100px' borderRadius='md' />
				<Skeleton height='36px' width='90px' borderRadius='md' />
			</HStack>
		</Flex>
	</Box>
);

const KeyMetricsSkeleton = () => (
	<Grid templateColumns={{ base: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' }} gap={4}>
		{Array.from({ length: 8 }).map((_, i) => (
			<Box
				key={i}
				bg='white'
				borderRadius='2xl'
				border='1px solid'
				borderColor='gray.200'
				p={5}>
				<HStack spacing={4}>
					<SkeletonCircle size='12' />
					<VStack align='start' spacing={2} flex={1}>
						<Skeleton height='12px' width='80px' borderRadius='md' />
						<Skeleton height='28px' width='60px' borderRadius='md' />
						<Skeleton height='10px' width='100px' borderRadius='md' />
					</VStack>
				</HStack>
			</Box>
		))}
	</Grid>
);

const SideBySideSkeleton = () => (
	<Grid templateColumns={{ base: '1fr', xl: 'repeat(2, 1fr)' }} gap={6}>
		{Array.from({ length: 2 }).map((_, i) => (
			<Box
				key={i}
				bg='white'
				borderRadius='2xl'
				border='1px solid'
				borderColor='gray.200'
				p={5}>
				<Skeleton height='18px' width='160px' borderRadius='md' mb={4} />
				<VStack spacing={3} align='stretch'>
					<Skeleton height='8px' borderRadius='full' />
					<Skeleton height='8px' borderRadius='full' />
					<Skeleton height='60px' borderRadius='lg' />
				</VStack>
			</Box>
		))}
	</Grid>
);

const ChartsSkeleton = () => (
	<VStack spacing={4} align='stretch'>
		<Skeleton height='22px' width='180px' borderRadius='md' />
		<Grid templateColumns={{ base: '1fr', lg: 'repeat(2, 1fr)' }} gap={6}>
			{Array.from({ length: 4 }).map((_, i) => (
				<Box
					key={i}
					bg='white'
					borderRadius='xl'
					border='1px solid'
					borderColor='gray.200'
					p={5}>
					<Skeleton height='16px' width='140px' borderRadius='md' mb={4} />
					<Skeleton height='180px' borderRadius='lg' />
				</Box>
			))}
		</Grid>
	</VStack>
);

const OverviewTabSkeleton = () => (
	<Grid templateColumns={{ base: '1fr', xl: 'repeat(2, 1fr)' }} gap={6}>
		{Array.from({ length: 4 }).map((_, i) => (
			<Box
				key={i}
				bg='white'
				borderRadius='2xl'
				border='1px solid'
				borderColor='gray.200'
				p={5}>
				<Skeleton height='18px' width='160px' borderRadius='md' mb={4} />
				<VStack spacing={3} align='stretch'>
					{Array.from({ length: 3 }).map((__, j) => (
						<Skeleton key={j} height='52px' borderRadius='lg' />
					))}
				</VStack>
			</Box>
		))}
	</Grid>
);

const DashboardSkeleton = () => (
	<Box w='100%'>
		<VStack spacing={6} align='stretch'>
			<HeaderSkeleton />
			<KeyMetricsSkeleton />
			<SideBySideSkeleton />
			<ChartsSkeleton />

			<Box bg='white' borderRadius='2xl' border='1px solid' borderColor='gray.200' p={2}>
				<Tabs colorScheme='teal'>
					<TabList border='none'>
						{['Overview', 'Team', 'Campaigns', 'Contacts'].map((label) => (
							<Tab key={label} isDisabled>
								<Skeleton height='14px' width={`${label.length * 9}px`} borderRadius='md' />
							</Tab>
						))}
					</TabList>
				</Tabs>
			</Box>

			<OverviewTabSkeleton />
		</VStack>
	</Box>
);

export default DashboardSkeleton;
